import { useQuery } from "@tanstack/react-query";
import { getOrganizationById } from "../api/organizations";

export function useOrganizationById(id?: string) {
    return useQuery({
        queryKey: ['company', id],
        queryFn: () => getOrganizationById(id!),
        throwOnError(error, _) {
            throw error;
        },
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        enabled: !!id,
        retry: 2,
        retryDelay: 1100,
    });
}